import { useNavigate } from "react-router-dom";
import aiBackground from "../assets/images/blog-hero.webp";  

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      
      {/* Background Image */}
      <div className="bg-gradient-to-br from-blue-50 via-white to-indigo-50"></div> 

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-blue-600/10"></div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 text-center">
        
        {/* Heading */}
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-6">
          Start optimizing your business with
          <span className="text-blue-600 block mt-3">
            Aizops Today
          </span>
        </h2>

        {/* Subtext */}
        <p className="text-black-600 text-base md:text-lg max-w-2xl mx-auto mb-10">
          Join the future of workforce management. Streamline your HR, payroll, 
          and operations with our all-in-one AI-powered platform.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate('/buy-plans')}
            className="px-10 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-lg"
          >
            Get Started Free
          </button>
          <button
            onClick={() => navigate('/pricing')}
            className="px-10 py-4 bg-transparent border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-semibold rounded-lg transition-all duration-300 transform hover:-translate-y-1 text-lg"
          >
            View Pricing
          </button>
        </div>

        {/* Simple Trust Badge */}
        
      </div>
    </section>
  );
};

export default CTASection;